export default function flattenGroupedEventTypes(groupedEventTypes) {
  return groupedEventTypes.map(([groupName, options]) => options).flat()
}
